export function useCustomserId() {
    return localStorage.getItem('customerId') || ''
  }